export default function({language}) {
    var config = {
        label: language["address-label"],
        placeholder: language["address-placeholder"],
        validators: ["mandatory", "minChars:2"],
        autoComplete: "street-address",
    };

    return {
        config,
        extendsType: "text-field"
    };
};
